import { createContext } from 'react';

const TreebankContext = createContext();

TreebankContext.displayName = 'TreebankContext';

export default TreebankContext;
